/* eslint-disable indent */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import EventIcon from 'material-ui-icons/Event';
import {
    handlecheckInChangeFactory, handlecheckOutChangeFactory,
    handleNightsChangeFactory, handleNightsEnterFactory,
    registerLandScapeForm
} from '../Utils/FilterChangeFunctions';
import moment from 'moment';

import { translate } from 'react-i18next';
import { TextField, CircularProgress } from 'material-ui';
import { handleSubmitFactory, componentDidMountFactory } from './CommonFunctions';

import AbstractSearchForm from './AbstractSearchForm';
import { DatePicker } from 'material-ui-pickers';
import { getForm } from './ExclusiveSearchForms/ExclusiveSearchFormFactory';
import { Button } from 'material-ui';
import DynIcon from '../Utils/DynIcon';
import SearchOptionsDialog from './SearchOptionsDialog';
import { setHotelsNew } from '../../actions/hotelsActions';
import { connect } from 'react-redux';


const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    }
};

const roomsValues = Array.from(Array(6).keys());
roomsValues.shift();

/**
 * Componente de busqueda destinos Exclusive
 *
 * @author Luciano Bustos
 */
class ExclusiveFormLandscape extends AbstractSearchForm {
    constructor(props) {
        super(props);
        registerLandScapeForm(this);

        const { classes, accountName } = props;
        this.accountName = accountName ? accountName : 'default';
        this.state = this.initState(classes);
        this.ExclusiveFormFTS = getForm(this.accountName);
    }

    doSearch = () => {
        handleSubmitFactory(this)();
    }

    componentDidMount = () => {
        //super.componentDidMount();
        componentDidMountFactory(this)();
    }

    resultHandler = (action, data) => {
        this.setState({ loading: false });
        if (data) {
            const hash = window.location.hash;
            this.props.dispatch(setHotelsNew(hash));
        }
    }

    handleUpdate = (action, data) => {
        switch (action) {
            case 'result':
                let sta = this.state;
                sta.exclusiveDestinationSelected = data.query.destination && data.query.destination.code ? data.query.destination.code : data.query.destination;
                this.setStateFromQuery(data.query, this);
                break;
            default:
                break;
        }
    }

    handleFault = error => {
        alert(error.message);
    }

    initState = (classes, eroskiData) => {
        return {
            classes: classes,
            inputError: false,
            totalRooms: 1,
            rooms: [
                {
                    adults: 2,
                    kids: [],
                    mealPlan: 'ALL',
                },
            ],
            checkOut: moment(this.START_DAY).add(1, 'days'),
            checkIn: moment(this.START_DAY),
            nights: 1,
            value: '',
            suggestions: [],
            selectedSuggestion: {},
            loading: false,
            dialogOpen: false,

            hasExclusiveForm: true,
            exclusiveFormSelected: true,
            exclusiveDestinationSelected: null,
            data: eroskiData || [],
        };
    };
 
    render() {
        const { classes, t } = this.props;
        const ExclusiveFormFTS = this.ExclusiveFormFTS;
        const totalAdults = this.state.rooms.reduce((acc, r) => acc + r.adults, 0);
        const totalKids = this.state.rooms.reduce((acc, r) => acc + r.kids.length, 0);
        return (
            <table width="100%" className="SearchFormLandscape">
                <tbody>
                    <td className="fts">
                        {ExclusiveFormFTS ?
                            <ExclusiveFormFTS
                                parent={this} value={this.state.exclusiveDestinationSelected}
                                accountName={this.accountName}
                                exclusiveDestinations={this.state.data}
                                width='100%'
                                hide={false}
                            />
                            : ''}
                    </td>
                    <td className="checkin">
                        <DatePicker
                            keyboard
                            label={t('COMMON.CHECK_IN')}
                            format={'DD/MM/YYYY'}
                            autoOk
                            className="cmsFormContainer"
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            disablePast
                            InputLabelProps={{
                                className: classes.inputLabelDate,
                            }}
                            keyboardIcon={
                                <EventIcon />
                            }
                            value={this.state.checkIn}
                            onChange={handlecheckInChangeFactory(this)}
                            animateYearScrolling={false}
                            disabled={this.state.loading}
                            minDateMessage={t('HOME.DATE_VALIDATION')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </td>
                    <td className="nights">
                        <TextField
                            label={t('COMMON.NIGHTS')}
                            className="cmsFormContainer"
                            value={this.state.nights}
                            onChange={handleNightsChangeFactory(this)}
                            onBlur={(e) => { handleNightsEnterFactory(e, this); }}
                            onKeyDown={(e) => { handleNightsEnterFactory(e, this); }}
                            type="number"
                            inputProps={{ min: 1, max: this.MAX_NIGHTS }}
                            disabled={this.state.loading}
                        />
                    </td>
                    <td className="checkout">
                        <DatePicker
                            keyboard
                            label={t('COMMON.CHECK_OUT')}
                            format={'DD/MM/YYYY'}
                            autoOk
                            className="cmsFormContainer"
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            disablePast
                            InputLabelProps={{
                                className: classes.inputLabelDate,
                            }}
                            keyboardIcon={
                                <EventIcon />
                            }
                            value={this.state.checkOut}
                            onChange={handlecheckOutChangeFactory(this)}
                            animateYearScrolling={false}
                            disabled={this.state.loading}
                            minDateMessage={t('HOME.DATE_VALIDATION')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </td>
                    <td className="adults">
                        <TextField
                            label={t('HOME.TOTAL_ADULTS')}
                            name={'adults'}
                            className="cmsFormContainer"
                            value={totalAdults}
                            onClick={this.handleOpenDialog}
                            disabled={this.state.loading} />
                    </td>
                    <td className="children">
                        <TextField
                            label={t('HOME.TOTAL_CHILDREN') + ' **'}
                            name={'children'}
                            className="cmsFormContainer"
                            value={totalKids}
                            onClick={this.handleOpenDialog}
                            disabled={this.state.loading} />
                    </td>
                    <td className="rooms">
                        <TextField
                            label={t('COMMON.ROOMS')}
                            name={'totalRooms'}
                            className="cmsFormContainer"
                            value={this.state.totalRooms}
                            onClick={this.handleOpenDialog}
                            disabled={this.state.loading}>
                        </TextField>
                        <SearchOptionsDialog
                            rooms={this.state.rooms}
                            totalRooms={this.state.totalRooms}
                            open={this.state.dialogOpen}
                            onClose={this.handleCloseDialog}
                        />
                    </td>
                    <td className="search">
                        <Button color="primary"
                            onClick={() => { this.doSearch(); }}
                            disabled={this.state.loading}
                            className="cmsButtonSearch">
                            {this.state.loading ?
                                <CircularProgress size={38} className="buttonProgressIcon" /> :
                                <DynIcon icon="Search"
                                    style={{
                                        color: 'var(--primary-button--text-color)',
                                        minWidth: '38px',
                                        height: '38px',
                                    }}
                                />
                            }
                        </Button>
                    </td>
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = state => ({
    hotels: state.hotelsRedux
});

ExclusiveFormLandscape.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    accountName: PropTypes.string.isRequired,
    nights: PropTypes.number.isRequired,
    onClose: PropTypes.func,
};
export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(ExclusiveFormLandscape)));


// WEBPACK FOOTER //
// ./src/components/SearchContent/ExclusiveFormLandscape.js